<template>
  <div id="reconnect_main_div">
    <CustomOverlay :show="show_overlay" :text="'Riconnessione in corso...'">
      <b-container class="min-vh-100">
        <b-row class="min-vh-100 justify-content-md-center align-items-center">
          <b-col class="text-center">
            <b-img fluid :src="logo" alt="welfarebit logo"></b-img>
            <h2 style="color:white;" class="mt-3">Riconnessione...</h2>
            <h5 v-if="ric_ko" style="color:red;" class="mt-3">{{ric_ko_text}}</h5>
          </b-col>
        </b-row>
      </b-container>
    </CustomOverlay>
  </div>
</template>


<script>
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'

export default {
  name: 'ReconnectLogin',
  data () {
    return {
      show_overlay : false,

      // Una stringa con eventuali errori di riconnessione:
      ric_ko : false,

      // Un testo per notificare la riconnessione fallita.
      ric_ko_text : "Riconnessione all'utente fallita.",

      // Un logo di welfarebit tanto per rendere tutto meno monotono...
      logo: require('@/assets/logos/welfarebit/logo_login.png')
    }
  },
  /**
   * Quando la view è stata montata procedo con il login.
   */
  mounted : function () {
    this.show_overlay = true;

    // Chiamiamo la action di vuex che interroga il backend e setta le info utente
    // nello store, la action ci restituisce il risultato della chiamata sia che vada
    // bene o male in modo da potersi comportare di conseguenza.
    this.$store.dispatch( 'reconnect_login', this.userdata ).then( () => {
      // Login ok! Andiamo alla home ( in realtà al menu perchè la home è cmq redirezionata qui )
      // non togliamo l'overlay, aspettiamo che il router faccia il suo lavoro.
      this.$router.push( { name : 'menu' } )
    })
    .catch( (error) => {

      this.show_overlay = false;

      // Controlliamo se la password è scaduta perchè in questo caso non c'è una stringa di errore
      // ma un oggetto con il solo attributo password_expired a true. In questo caso settiamo
      // manualmente la stringa di errore invece di far vedere il messaggio nella modale.
      if ( Object.prototype.hasOwnProperty.call( error.response.data, 'password_expired' ) &&
          error.response.data.password_expired === true ) {
        this.ric_ko_text = "Password utente scaduta. Riconnessione fallita."
      } else {
        generalLib.backend_error_message_box( this, error.response.data );
      }

      this.ric_ko = true;

    });
  },
  props : {
    /**
     * Si tratta dei dati criptati dell'utente che dobbiamo inviare al
     * backend per effettuare l'accesso.
     */
    userdata: {
      type: String,
      required: true
    }
  },
  components: {
    CustomOverlay
  }
}
</script>

<style scope>
/* Applichiamo il colore di default Welfarebit al div principale
   e non al body per evitare di far saltare la colorazione di tutte
   le skin personalizzate. Va bene tale colore in quanto questa pagina
   serve solo al backoffice ed in questo modo si vede bene il logo
   che ha il testo bianco */
#reconnect_main_div {
  background: #373F66;
}
</style>

